import MInputBase from "./MInputBase";

export default MInputBase;